<template>
    <!--         LOCATION       -->
    <!-- <div class="locationAndApptType">
        <div class="flex center">
            <div class="flex-1 right-15">
                <h5 class="e-textlabel">Place of Service </h5>
                <select v-model="selectedPlaceOfService" @change="handleSelectedPlaceOfService" required>
                    <option :value="place.code" v-for="place in placesOfService" :key="place.code">
                        {{place.code}} - {{place.name }}
                    </option>
                </select>
            </div> -->

            <!--         APPOINTMENT TYPE      -->
            <!-- <div class="flex-1">
                <h5 class="e-textlabel">Appointment Type</h5>
                <select v-model="eventType" id="apptType" @change="handleEventType" required>
                    <option v-for="option in apptType" v-bind:key="option.id">
                        {{ option }}
                    </option>
                </select>
            </div>
        </div>
    </div> -->
    <div>
        <!--         LOCATION       -->
        <div class="mb-5">
            <div class="appt-section-title fw-bolder">Place of Service*</div>          
            <div class="row ms-0">
                <!-- <div class="col-sm-3 calendar-search-card d-flex justify-content-between align-items-center me-3 py-2">
                    <span class="calendar-filter-view-label">All Type</span>
                    <Toggle
                        id="allType"
                        class="toggle-switch"
                        v-model="placeOfServiceType.allType"
                        labelClass="switch"
                        spanClass="slider"
                        @input="(value) => handlePlaceOfServiceTypeChange(value, 'ALL_TYPE')"
                    />
                </div> -->
                <div class="col-sm-3 calendar-search-card d-flex justify-content-between align-items-center me-3 py-2">
                    <span class="calendar-filter-view-label">Telehealth</span>
                    <Toggle
                        id="telehealth"
                        class="toggle-switch"
                        v-model="placeOfServiceType.telehealth"
                        labelClass="switch"
                        spanClass="slider"
                        @input="(value) => handlePlaceOfServiceTypeChange(value, 'TELEHEALTH')"
                    />
                </div>
                <!-- <div class="col-sm-3 calendar-search-card d-flex justify-content-between align-items-center py-2">
                    <span class="calendar-filter-view-label">In office</span>
                    <Toggle
                        id="inOffice"
                        class="toggle-switch"
                        v-model="placeOfServiceType.inOffice"
                        labelClass="switch"
                        spanClass="slider"
                        @input="(value) => handlePlaceOfServiceTypeChange(value, 'IN_OFFICE')"
                    />
                </div> -->
                <div class="col-sm-3 calendar-search-card d-flex justify-content-between align-items-center py-2">
                    <span class="calendar-filter-view-label flex gap-2 align-items-center">Third Party
                        <img id="third-party-info" src="@/assets/px/info-icon.svg" alt="Info" height="15" />
                         <b-tooltip target="#third-party-info" triggers="hover" placement="bottom">Set up a call through Teams, Zoom, Teladoc, etc.</b-tooltip>
                    </span>
                    <Toggle
                        id="thirdParty"
                        class="toggle-switch"
                        v-model="placeOfServiceType.thirdParty"
                        labelClass="switch"
                        spanClass="slider"
                        @input="(value) => handlePlaceOfServiceTypeChange(value, 'THIRD_PARTY')"
                    />
                </div>
            </div>
        </div>
        <!--         APPOINTMENT TYPE      -->
        <div v-if="placeOfServiceType.telehealth">
            <div class="appt-section-title fw-bolder">Appointment Type*</div>
            <div class="d-flex align-items-center">
                <AppointmentTypeCard id="individual" label="Individual" v-model="appointmentType.individual" @input="(value) => handleAppointmentTypeChange(value, 'INDIVIDUAL')">
                    <template v-slot="{ hoverOrSelected }">
                        <svg :style="{ fill: hoverOrSelected ? '#ffffff' : '#595BC4' }" width="25" height="25" viewBox="0 0 31 36" xmlns="http://www.w3.org/2000/svg">
                        <path d="M29.6325 25.6491L26.4316 20.1055C25.7816 18.9705 24.7303 18.12 23.4844 17.7211C22.2388 17.3223 20.889 17.4042 19.7006 17.9508C17.0135 19.1684 13.9319 19.1684 11.2448 17.9508C10.0566 17.4049 8.70735 17.3233 7.46201 17.7219C6.21692 18.1207 5.16578 18.9709 4.51575 20.1054L1.31295 25.6491C0.192518 27.59 0.192518 29.981 1.31319 31.9216C2.43362 33.8625 4.5044 35.0579 6.74545 35.0579H24.1999C26.441 35.0579 28.5117 33.8625 29.6322 31.9216C30.7528 29.9809 30.7528 27.5899 29.6324 25.6491L29.6325 25.6491ZM28.2302 31.1108C27.8301 31.8254 27.2445 32.4187 26.535 32.828C25.8256 33.2372 25.0189 33.4473 24.2 33.4362H6.74552C5.0842 33.4352 3.54937 32.5489 2.71823 31.1103C1.88735 29.6719 1.88608 27.8993 2.71527 26.4599L5.9156 20.9163H5.91584C6.36594 20.131 7.09341 19.5425 7.9552 19.2664C8.817 18.9905 9.75114 19.0467 10.5736 19.424C12.1127 20.122 13.7831 20.483 15.4729 20.483C17.1626 20.483 18.8331 20.122 20.3722 19.424C21.1944 19.0459 22.1285 18.989 22.9905 19.2651C23.8526 19.541 24.5801 20.1297 25.0299 20.9151L28.2305 26.4599C28.6489 27.1633 28.8699 27.9665 28.8699 28.7853C28.8699 29.6038 28.6489 30.4072 28.2305 31.1107L28.2302 31.1108ZM15.4727 16.7805C17.6292 16.7805 19.6972 15.9239 21.2222 14.3991C22.7469 12.8742 23.6036 10.8061 23.6036 8.64963C23.6036 6.49321 22.7467 4.42515 21.222 2.9004C19.697 1.37545 17.6289 0.519043 15.4725 0.519043C13.3161 0.519043 11.248 1.3759 9.72326 2.90065C8.19857 4.4256 7.34191 6.49372 7.34191 8.65014C7.34438 10.8058 8.20199 12.8724 9.72624 14.3966C11.2505 15.9209 13.3171 16.7783 15.4727 16.7805ZM15.4727 2.1385C17.1996 2.1385 18.856 2.82464 20.0771 4.04572C21.2984 5.2668 21.9843 6.92319 21.9843 8.65007C21.9843 10.3772 21.2984 12.0333 20.0771 13.2546C18.856 14.4757 17.1996 15.1616 15.4727 15.1616C13.7459 15.1616 12.0895 14.4757 10.8684 13.2546C9.64706 12.0333 8.96117 10.3771 8.96117 8.65007C8.9629 6.92369 9.64953 5.26858 10.8704 4.04775C12.0913 2.82711 13.7464 2.14052 15.4727 2.1385Z"/>
                        </svg>
                    </template>  
                </AppointmentTypeCard>
                <AppointmentTypeCard id="group" label="Group" v-model="appointmentType.group" @input="(value) => handleAppointmentTypeChange(value, 'GROUP')">
                    <template v-slot="{ hoverOrSelected }">
                        <svg :style="{ fill: hoverOrSelected ? '#ffffff' : '#595BC4' }" width="40" height="25" viewBox="0 0 60 33" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.3409 14.8893C20.2346 14.8893 16.918 11.5726 16.918 7.46638C16.918 3.36014 20.2346 0.043457 24.3409 0.043457C28.4471 0.043457 31.7638 3.36014 31.7638 7.46638C31.7638 11.5726 28.4471 14.8893 24.3409 14.8893ZM24.3409 1.62297C21.1296 1.62297 18.4974 4.25518 18.4974 7.46648C18.4974 10.6778 21.1296 13.31 24.3409 13.31C27.5522 13.31 30.1844 10.6778 30.1844 7.46648C30.1844 4.25518 27.5522 1.62297 24.3409 1.62297Z"/>
                        <path d="M39.6591 15.5209C36.7636 15.5209 34.4473 13.2045 34.4473 10.309C34.4473 7.41351 36.7637 5.09717 39.6591 5.09717C42.5547 5.09754 44.8707 7.41398 44.8707 10.309C44.8707 13.2046 42.5547 15.5209 39.6591 15.5209ZM39.6591 6.67687C37.6586 6.67687 36.0266 8.30875 36.0266 10.3094C36.0266 12.3101 37.6585 13.942 39.6591 13.942C41.6593 13.9416 43.2917 12.3097 43.2917 10.309C43.2917 8.30884 41.6594 6.67687 39.6591 6.67687Z"/>
                        <path d="M9.02242 15.5209C6.12689 15.5209 3.81055 13.2045 3.81055 10.309C3.81055 7.41351 6.12699 5.09717 9.02242 5.09717C11.9179 5.09717 14.2343 7.41361 14.2343 10.309C14.2343 13.2046 11.9178 15.5209 9.02242 15.5209ZM9.02242 6.67687C7.02184 6.67687 5.38987 8.30875 5.38987 10.3094C5.38987 12.3101 7.02175 13.942 9.02242 13.942C11.0231 13.942 12.655 12.3101 12.655 10.3094C12.655 8.30875 11.0231 6.67687 9.02242 6.67687Z"/>
                        <path d="M39.7139 27.1551C37.6083 27.1551 36.2922 27.0497 35.1865 26.8918L34.5549 26.7864V25.8915C34.5549 23.6804 33.8704 21.4695 32.5543 19.4689L32.291 19.1002L32.5014 18.679C33.9229 15.8364 36.7655 13.9937 39.661 13.9937C44.0305 13.9937 47.821 17.942 47.8734 22.6798C47.8738 27.155 43.7148 27.1551 39.7139 27.1551ZM36.1343 25.4178C37.0292 25.5232 38.1349 25.5757 39.7139 25.5757C44.715 25.5757 46.2944 25.1545 46.2944 22.6802C46.2419 18.8372 43.1885 15.573 39.6614 15.573C37.4503 15.573 35.2919 16.8891 34.0812 18.9947C35.3444 20.9953 36.0289 23.2067 36.1343 25.4177V25.4178Z"/>
                        <path d="M51.788 14.4638C48.8925 14.4638 46.5762 12.1473 46.5762 9.25191C46.5762 6.35639 48.8926 4.04004 51.788 4.04004C54.6836 4.04041 56.9996 6.35686 56.9996 9.25191C56.9996 12.1474 54.6836 14.4638 51.788 14.4638ZM51.788 5.61974C49.7875 5.61974 48.1555 7.25162 48.1555 9.25229C48.1555 11.253 49.7874 12.8848 51.788 12.8848C53.7882 12.8845 55.4206 11.2526 55.4206 9.25191C55.4206 7.25171 53.7883 5.61974 51.788 5.61974Z"/>
                        <path d="M51.8389 26.0979C49.7333 26.0979 48.4172 25.9925 47.3115 25.8346L46.6799 25.7292V24.8343C46.6799 22.6233 45.9954 20.4123 44.6793 18.4117L44.416 18.0431L44.6264 17.6219C46.0479 14.7793 48.8905 12.9365 51.786 12.9365C56.1555 12.9365 59.946 16.8848 59.9984 21.6226C59.9988 26.0979 55.8398 26.0979 51.8389 26.0979ZM48.2593 24.3607C49.1542 24.4661 50.2599 24.5186 51.8389 24.5186C56.84 24.5186 58.4194 24.0974 58.4194 21.6231C58.3669 17.7801 55.3135 14.5159 51.7864 14.5159C49.5753 14.5159 47.4169 15.832 46.2062 17.9376C47.4694 19.9382 48.1539 22.1496 48.2593 24.3606V24.3607Z"/>
                        <path d="M9.02127 27.1557C5.02041 27.1557 0.861328 27.1557 0.861328 22.6807C0.861328 17.9954 4.59925 13.9946 9.02127 13.9946C11.9693 13.9946 14.7594 15.8374 16.1809 18.68L16.3913 19.1012L16.128 19.4699C14.8119 21.4704 14.1274 23.6286 14.1803 25.84V26.7349L13.5486 26.8403C12.4433 27.0503 11.1272 27.1557 9.02127 27.1557ZM9.02127 15.574C5.49411 15.574 2.44075 18.8906 2.44075 22.6811C2.44075 25.1554 4.02017 25.5766 9.02127 25.5766C10.6007 25.5766 11.706 25.5241 12.6009 25.4187C12.6534 23.2077 13.3379 20.9967 14.6015 18.9961C13.3907 16.8902 11.2322 15.5741 9.02127 15.5741V15.574Z"/>
                        <path d="M24.3411 32.1568C18.2872 32.1568 12.5488 32.1568 12.5488 25.892C12.5488 19.2061 18.0766 13.3101 24.3411 13.3101C30.6057 13.3101 36.1334 19.2061 36.1334 25.892C36.1334 32.1568 30.3949 32.1568 24.3411 32.1568ZM24.3411 14.8895C18.9188 14.8895 14.1282 20.0485 14.1282 25.8921C14.1282 30.1562 17.2341 30.5775 24.3411 30.5775C31.4482 30.5775 34.5541 30.1563 34.5541 25.8921C34.5541 20.0486 29.7634 14.8895 24.3411 14.8895Z"/>
                        </svg>
                    </template>
                </AppointmentTypeCard>
                <AppointmentTypeCard id="family" label="Family" v-model="appointmentType.family" @input="(value) => handleAppointmentTypeChange(value, 'FAMILY')">
                    <template v-slot="{ hoverOrSelected }">
                        <svg :style="{ fill: hoverOrSelected ? '#ffffff' : '#595BC4' }" width="25" height="25" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31.0668 10.6056C32.2236 9.53147 32.9675 7.96134 32.9675 6.22609C32.9675 2.92063 30.282 0.234863 26.9766 0.234863C23.6711 0.234863 20.9856 2.92063 20.9856 6.2258C20.9856 7.96112 21.7292 9.48971 22.8864 10.6054C21.2338 10.812 19.9527 12.1755 19.9527 13.8693V14.2411C19.2916 13.9932 18.6304 13.8693 17.8868 13.8693C16.6888 13.8693 15.5731 14.2411 14.6229 14.861C14.1272 13.9107 13.1767 13.2084 12.0613 13.0845C13.2182 12.0103 13.9621 10.4402 13.9621 8.70491C13.9621 5.39945 11.2766 2.71397 7.97113 2.71397C4.66567 2.71397 1.9802 5.39945 1.9802 8.70491C1.9802 10.4402 2.72376 11.9688 3.88094 13.0845C2.2284 13.2911 0.947266 14.6546 0.947266 16.3484V29.9831C0.947266 30.4376 1.31906 30.8094 1.77354 30.8094C2.22804 30.8094 2.59981 30.4376 2.59981 29.9831V16.3484C2.59981 15.4394 3.34337 14.6958 4.25235 14.6958H11.6895C12.4746 14.6958 13.1357 15.2743 13.3008 16.0181C12.433 17.0511 11.8961 18.4145 11.8961 19.8605C11.8961 21.5958 12.6397 23.1244 13.7969 24.2401C12.1443 24.4467 10.8632 25.8102 10.8632 27.504V32.8753C10.8632 33.3298 11.235 33.7016 11.6895 33.7016C12.144 33.7016 12.5157 33.3298 12.5157 32.8753V27.504C12.5157 26.595 13.2593 25.8514 14.1683 25.8514H21.6054C22.5144 25.8514 23.2579 26.595 23.2579 27.504V32.8753C23.2579 33.3298 23.6297 33.7016 24.0842 33.7016C24.5387 33.7016 24.9105 33.3298 24.9105 32.8753V27.504C24.9105 25.8099 23.6297 24.4052 21.9768 24.2401C23.1337 23.1659 23.8776 21.5958 23.8776 19.8605C23.8776 17.9598 22.9686 16.266 21.605 15.1503V15.1091V13.8695C21.605 12.9605 22.3486 12.217 23.2576 12.217H30.6947C31.6037 12.217 32.3472 12.9605 32.3472 13.8695V27.5042C32.3472 27.9587 32.719 28.3305 33.1735 28.3305C33.628 28.3305 33.9998 27.9587 33.9998 27.5042V13.8695C34.0001 12.1754 32.7193 10.7707 31.0664 10.6056L31.0668 10.6056ZM3.63208 8.70491C3.63208 6.3085 5.57399 4.36652 7.97047 4.36652C10.3669 4.36652 12.3089 6.30843 12.3089 8.70491C12.3089 11.1014 10.3669 13.0433 7.97047 13.0433C5.57399 13.0433 3.63208 11.1014 3.63208 8.70491ZM22.2249 19.8606C22.2249 22.257 20.2829 24.199 17.8865 24.199C15.4903 24.199 13.5484 22.2571 13.5484 19.8606C13.5484 18.7864 13.9202 17.836 14.5813 17.0511C14.7052 16.9684 14.8292 16.8445 14.9119 16.7206C15.697 15.977 16.7299 15.5225 17.8867 15.5225C20.2829 15.5222 22.2249 17.4641 22.2249 19.8606ZM22.6382 6.22587C22.6382 3.82947 24.5801 1.88748 26.9765 1.88748C29.3729 1.88777 31.3149 3.82969 31.3149 6.22587C31.3149 8.62227 29.373 10.5643 26.9765 10.5643C24.5801 10.5643 22.6382 8.62235 22.6382 6.22587Z"/>
                        </svg>
                    </template>
                </AppointmentTypeCard>
                <AppointmentTypeCard id="couple" label="Couple" v-model="appointmentType.couple" @input="(value) => handleAppointmentTypeChange(value, 'COUPLE')">
                    <template v-slot="{ hoverOrSelected }">
                        <svg :style="{ fill: hoverOrSelected ? '#ffffff' : '#595BC4' }" width="25" height="25" viewBox="0 0 35 33" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28.8003 23.7755C30.2281 22.4279 31.1454 20.0664 31.1454 17.8713C31.1454 14.6925 29.1892 12.5562 26.2768 12.5562C23.3648 12.5562 21.4082 14.6922 21.4082 17.8713C21.4082 20.0654 22.3249 22.4253 23.7508 23.7733C22.6717 24.0484 21.6558 24.5341 20.7652 25.221C19.2606 23.2981 17.1148 21.9034 14.6467 21.3709C16.6479 19.7072 17.9539 16.4787 17.9539 13.4921C17.9539 9.44013 15.4674 6.71729 11.7663 6.71729C8.06512 6.71729 5.57862 9.44013 5.57862 13.4921C5.57862 16.4788 6.88455 19.7072 8.88576 21.3709C4.10381 22.4025 0.507812 26.6607 0.507812 31.7467C0.507812 32.1281 0.816266 32.4365 1.19758 32.4365H34.3098C34.6911 32.4365 34.9996 32.1281 34.9996 31.7467C34.9996 27.9097 32.3576 24.686 28.8001 23.7759L28.8003 23.7755ZM22.7882 17.8713C22.7882 15.4443 24.1245 13.9357 26.2769 13.9357C28.4293 13.9357 29.7656 15.4439 29.7656 17.8713C29.7656 20.7174 28.0378 23.5105 26.2769 23.5105C24.516 23.5105 22.7882 20.7173 22.7882 17.8713ZM6.95906 13.4921C6.95906 10.2147 8.84605 8.0968 11.7667 8.0968C14.6878 8.0968 16.5744 10.2146 16.5744 13.4921C16.5744 17.3461 14.193 21.1285 11.7667 21.1285C9.34044 21.1285 6.95906 17.3458 6.95906 13.4921ZM1.91396 31.0564C2.26772 26.2828 6.26425 22.5077 11.1263 22.5077H12.4076C17.2694 22.5077 21.2662 26.2828 21.6196 31.0564H1.91396ZM22.9904 31.0564C22.8802 29.3517 22.3687 27.7587 21.5456 26.3657C22.7523 25.4121 24.238 24.8894 25.79 24.8894H26.764C30.3121 24.8894 33.239 27.5981 33.5859 31.056L22.9904 31.0564Z"/>
                            <path d="M26.0311 0.402832C25.1956 0.402832 24.3826 0.74173 23.8041 1.32856L23.7077 1.42498L23.6145 1.33147C23.0317 0.741378 22.2187 0.403194 21.3839 0.403194C20.5405 0.403194 19.7478 0.73195 19.1508 1.32893C18.5535 1.92626 18.2251 2.72004 18.2266 3.5635C18.228 4.40406 18.5568 5.19309 19.1479 5.77962L23.2195 9.85803C23.3543 9.99287 23.5309 10.0603 23.7074 10.0603C23.8839 10.0603 24.0604 9.99287 24.1952 9.85803L28.2646 5.78175C28.8586 5.19094 29.1867 4.40335 29.1881 3.5635C29.1896 2.72006 28.8615 1.92659 28.2638 1.32893C27.6672 0.731588 26.8744 0.402832 26.0311 0.402832ZM27.2902 4.80425C27.2888 4.80643 27.2877 4.80751 27.2862 4.80896L23.7081 8.39411L20.1255 4.80423C19.792 4.47366 19.6076 4.03146 19.6068 3.56065C19.6061 3.08655 19.7906 2.63964 20.127 2.30362C20.4633 1.96726 20.9099 1.78204 21.3847 1.78204C21.8531 1.78204 22.3076 1.97051 22.6363 2.30362L23.2199 2.88791C23.4892 3.15722 23.926 3.15722 24.1953 2.88791L24.7828 2.30037C25.4371 1.63743 26.6212 1.63597 27.2889 2.30363C27.6249 2.63963 27.8098 3.08655 27.8091 3.56066C27.8083 4.03186 27.6238 4.4737 27.2904 4.80424L27.2902 4.80425Z"/>
                        </svg>
                    </template>
                </AppointmentTypeCard>
                <AppointmentTypeCard id="others" label="Others" v-model="appointmentType.others" @input="(value) => handleAppointmentTypeChange(value, 'OTHERS')">
                    <template v-slot="{ hoverOrSelected }">
                        <svg :style="{ fill: hoverOrSelected ? '#ffffff' : '#BCC0FF' }" width="25" height="25" viewBox="0 0 32 30" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5.09091" cy="20.0904" r="4.24091" stroke="#595BC4" stroke-width="1.7"/>
                            <circle cx="19.6378" cy="5.54501" r="4.24091" stroke="#595BC4" stroke-width="1.7"/>
                            <circle cx="26.9093" cy="24.4542" r="4.24091" stroke="#595BC4" stroke-width="1.7"/>
                        </svg>
                    </template>
                </AppointmentTypeCard>
            </div>
        </div>
    </div>
</template>

<script>
    import AppointmentTypeCard from './AppointmentTypeCard';
    export default {
        name: 'LocationApptType',
        props: {
            modalOpen: Boolean,
            typeofAppt: { required: false },
            rooms: {
                type: Array,
                required: true,
            },
        },
        components: {
            AppointmentTypeCard
        },
        data() {
            return {
                apptType: ['Individual', 'Group', 'Couple', 'Family', 'Other'],
                eventType: null,
                room: null,
                selectedPlaceOfService: null,
                placesOfService: [
                    {
                        code: '02',
                        name: 'Telehealth'
                    },
                    {
                        code: '11',
                        name: 'Office'
                    },

                ],
                placeOfServiceType: {
                    allType: false,
                    telehealth: true,
                    inOffice: false,
                    thirdParty: false
                },
                appointmentType: {
                    individual: true,
                    group: false,
                    family: false,
                    couple: false,
                    others: false
                }
            }
        },
        methods: {
            handlePlaceOfServiceTypeChange(value, type) {
                switch (type) {
                    // case 'ALL_TYPE':
                    //     if (value) {
                    //         this.placeOfServiceType.telehealth = false;
                    //         this.placeOfServiceType.inOffice = false;
                    //         this.handleSelectedPlaceOfService('all');
                    //     } else {
                    //         this.handleSelectedPlaceOfService(null);
                    //     }
                    //     break;
                    case 'TELEHEALTH':
                        if (value) {
                            this.placeOfServiceType.allType = false;
                            this.placeOfServiceType.telehealth = true;
                            this.placeOfServiceType.inOffice = false;
                            this.placeOfServiceType.thirdParty = false;
                            this.handleSelectedPlaceOfService('02');
                        } else {
                            this.placeOfServiceType.thirdParty = true;
                            this.handleSelectedPlaceOfService('12');
                            this.handleAppointmentTypeChange(value, 'INDIVIDUAL');
                        }
                        break;
                    // case 'IN_OFFICE':
                    //     if (value) {
                    //         this.placeOfServiceType.allType = false;
                    //         this.placeOfServiceType.telehealth = false;
                    //         this.handleSelectedPlaceOfService('11');
                    //     } else {
                    //         this.handleSelectedPlaceOfService(null);
                    //     }
                    //     break;
                    case 'THIRD_PARTY':
                        if (value) {
                            this.placeOfServiceType.allType = false;
                            this.placeOfServiceType.telehealth = false;
                            this.placeOfServiceType.inOffice = false;
                            this.placeOfServiceType.thirdParty = true;
                            this.handleSelectedPlaceOfService('12');   
                            this.handleAppointmentTypeChange(value, 'INDIVIDUAL');
                        } else {
                            this.placeOfServiceType.telehealth = true;
                            this.handleSelectedPlaceOfService('02');
                        }
                        break;
                }
            },

            handleAppointmentTypeChange(value, type) {
                switch (type) {
                    case 'INDIVIDUAL':
                        if (value) {
                            this.appointmentType.group = false;
                            this.appointmentType.family = false;
                            this.appointmentType.couple = false;
                            this.appointmentType.others = false;
                            this.handleEventType('Individual');
                        } else {
                            this.handleEventType(null);
                        }
                        break;
                    case 'GROUP':
                        if (value) {
                            this.appointmentType.individual = false;
                            this.appointmentType.family = false;
                            this.appointmentType.couple = false;
                            this.appointmentType.others = false;
                            this.handleEventType('Group');
                        } else {
                            this.handleEventType(null);
                        }
                        break;
                    case 'COUPLE':
                        if (value) {
                            this.appointmentType.individual = false;
                            this.appointmentType.group = false;
                            this.appointmentType.family = false;
                            this.appointmentType.others = false;
                            this.handleEventType('Couple');
                        } else {
                            this.handleEventType(null);
                        }
                        break;
                    case 'FAMILY':
                        if (value) {
                            this.appointmentType.individual = false;
                            this.appointmentType.group = false;
                            this.appointmentType.couple = false;
                            this.appointmentType.others = false;
                            this.handleEventType('Family');
                        } else {
                            this.handleEventType(null);
                        }
                        break;
                    case 'OTHERS':
                        if (value) {
                            this.appointmentType.individual = false;
                            this.appointmentType.group = false;
                            this.appointmentType.couple = false;
                            this.appointmentType.family = false;
                            this.handleEventType('Other');
                        } else {
                            this.handleEventType(null);
                        }
                        break;
                }
            },

            handleSelectedPlaceOfService(value) {
                this.$emit('selectedPlaceOfService', value);
            },

            handleEventType(value) {
                this.$emit('setApptType', value);
            },

            resetAll() {
                this.placeOfServiceType.allType = false;
                this.placeOfServiceType.telehealth = false;
                this.placeOfServiceType.inOffice = false;
                this.appointmentType.individual = false;
                this.appointmentType.group = false;
                this.appointmentType.family = false;
                this.appointmentType.couple = false;
                this.appointmentType.others = false;
            }
        },

        watch: {
            modalOpen() {
                //clears the appointment location & appointment type everytime the modal closes
                if (this.modalOpen == false) {
                    this.room = null;
                    this.selectedPlaceOfService = null
                    this.eventType = null;
                    this.resetAll();
                }
            },
            eventType() {
                if (this.eventType !== 'Individual') {
                    this.$emit('getAllServices');
                    this.clients = Array.isArray(this.clients) ? this.clients : [this.clients];
                } else {
                    this.clients = Array.isArray(this.clients) ? this.clients[0] : this.clients;
                }
            },
            typeofAppt(){
                if (this.typeofAppt !== null) {
                    this.eventType = this.typeofAppt;
                    if(this.typeofAppt === 'Individual') {
                        this.appointmentType.individual = true;
                    }
                }
            }
        },

        created() {
            if (this.typeofAppt !== null) {
                this.eventType = this.typeofAppt;
                if(this.typeofAppt === 'Individual') {
                    this.appointmentType.individual = true;
                }
            }
        },
    };
</script>

<style scoped></style>
